import { ResourcesConfig } from 'aws-amplify';
import { environment } from '@env/environment';

export const amplifyConfig: ResourcesConfig = {
  Auth: {
    Cognito: {
      userPoolId: environment.userPoolId,
      userPoolClientId: environment.userPoolWebClientId,
      // identityPoolId: environment.identityPoolId,
      signUpVerificationMethod: 'code',
      loginWith: {
        email: true,
        phone: true,
        username: true,
        oauth: {
          domain: environment.cognitoDomain,
          redirectSignIn: [environment.cognitoRedirectUrl],
          redirectSignOut: [environment.baseUrl],
          responseType: 'code',
          scopes: [
            'email',
            'openid',
            'profile',
            'aws.cognito.signin.user.admin',
          ],
        },
      },
    },
  },

  API: {
    GraphQL: {
      endpoint: environment.graphqlEndpoint,
      region: environment.region,
      defaultAuthMode: 'userPool',
    },
    REST: {
      api: {
        endpoint: environment.apiUrl,
        region: environment.region,
      },
    },
  },
};

